import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

interface FeatureWidgetViewProps extends WithClassName {
  elementId?: string
  topHeadline?: React.ReactNode
  headline?: React.ReactNode
  text?: React.ReactNode
  content?: React.ReactNode
  buttons?: React.ReactNode | React.ReactNode[]
  alternativeBackground?: boolean
  objectFit?: string | null | undefined
}

export const FeatureWidgetView = React.memo(
  ({
    elementId,
    headline,
    topHeadline,
    text,
    buttons,
    content,
    className,
    alternativeBackground,
    objectFit
  }: FeatureWidgetViewProps) => {
    return (
      <section
        id={elementId}
        className={classNames(
          "feature-widget",
          objectFit,
          {
            "bg-level-1": alternativeBackground
          },
          className
        )}
      >
        <div className="feature-widget__header">
          {topHeadline ? (
            <div className="feature-widget__top-headline">{topHeadline}</div>
          ) : null}
          {headline ? (
            <div className="feature-widget__title">{headline}</div>
          ) : null}
          {text ? <div className="feature-widget__subtitle">{text}</div> : null}
        </div>

        <div className="feature-widget__content">{content}</div>

        {buttons ? <div className="feature-widget__cta">{buttons}</div> : null}
      </section>
    )
  }
)
